<span *ngIf="showText">Laddar</span>
<div *ngIf="isLoading" class="lds-ring">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
